/* eslint-disable react-hooks/exhaustive-deps */

import React, { ReactElement, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { getTrainingGroup } from '../api/training-group'
import { TrainingGroup as TrainingGroupType } from '../types/training'
import AdminCategory from './admin/category'
import AdminPart from './admin/part'
import AdminTraining from './admin/training'
import TrainingGroupScreen from './admin/training-group'

const ProtectedRoutesTraining = (): ReactElement => {
  const [queryParams] = useSearchParams()

  const type = queryParams.get('type')
  const trainingId = queryParams.get('training_id')
  const categoryId = queryParams.get('category_id')
  const partId = queryParams.get('part_id')

  const verifyRenderTrainingGroup = type && !trainingId && !categoryId
  const verifyRenderTraining = type && trainingId && !categoryId && !partId
  const verifyRenderCategory = type && trainingId && categoryId && !partId
  const verifyRenderpart = type && trainingId && categoryId && partId

  const [trainingsGroup, setTrainingsGroup] = useState<
    TrainingGroupType | undefined | null
  >(undefined)

  useEffect(() => {
    if (type) {
      getTrainingGroup(type, trainingId, categoryId, partId).then((data) => {
        if (typeof data !== 'number') {
          setTrainingsGroup(data)
        } else {
          setTrainingsGroup(null)
        }
      })
    }
  }, [])

  if (trainingsGroup === undefined) {
    return <></>
  }

  if (trainingsGroup) {
    if (verifyRenderpart && categoryId && partId) {
      return (
        <AdminPart
          categoryId={categoryId}
          partId={partId}
          trainingsGroup={trainingsGroup}
        />
      )
    }
    if (verifyRenderCategory && categoryId) {
      return (
        <AdminCategory
          categoryId={categoryId}
          trainingsGroup={trainingsGroup}
        />
      )
    }
    if (verifyRenderTraining) {
      return <AdminTraining trainingsGroup={trainingsGroup} />
    }
    if (verifyRenderTrainingGroup) {
      return <TrainingGroupScreen trainingsGroup={trainingsGroup} />
    }
  }

  return <>not found</>
}

export default ProtectedRoutesTraining
